import { Navigate } from 'react-router-dom';

import { useGeoMarkupStore } from '@/store';
import {
  selectCurrentWorkspaceId,
  selectWorkspaces,
} from '@/store/selectors/authSelectors';

/**
 * Redirects legacy `/settings` route to workspace-scoped `/w/:shortId/settings`.
 * Must be wrapped in ProtectedRoute at the router level.
 */
export function SettingsRedirect() {
  const workspaces = useGeoMarkupStore(selectWorkspaces);
  const currentWorkspaceId = useGeoMarkupStore(selectCurrentWorkspaceId);

  const targetWorkspace =
    workspaces.find((workspace) => workspace.id === currentWorkspaceId) ??
    workspaces[0];

  if (targetWorkspace) {
    return <Navigate to={`/w/${targetWorkspace.shortId}/settings`} replace />;
  }

  return <Navigate to="/onboarding" replace />;
}
